module.exports = __webpack_public_path__ + "static/media/voyager.5f3e4454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/commanders/voyager.png
// module id = 2069
// module chunks = 0